<template>
  <div class="form-build-render">
    <form-build-item-wrapper
      ref="itemWrapper"
      v-for="(formItem, formIndex) in formItemList"
      :key="formItem.uuid"
      :widget="formItem"
      :formData.sync="computedFormData"
      :globalData="globalData"
      :formConfigList="formItemList"
      :itemClass="formItem.itemClass"
      :validateInfo="formItem.validateInfo"
      :renderSence="formItem.componentConfig.renderSence || renderSence"
      :itemRuleConfig="formRuleConfig[formItem.componentConfig.uuid]"
      @update:widget="updateFormItem($event, formIndex)"
      @handleComponentEvent="handleComponentEvent"
      @click.native="itemOptionEvent(formIndex, 'clickFormItemList')"
      @formItemOptionAction="
        itemOptionEvent(
          {
            actionName: $event,
            formItem: formItem
          },
          'formItemOptionAction'
        )
      "
      @formEventEmit="formEventEmit"
      @validate-changed="handleConfigFormValidate"
    >
    </form-build-item-wrapper>
  </div>
</template>
<script>
import FormBuildItemWrapper from '../item-wrapper/form-build-item-wrapper'

export default {
  name: 'FormBuildRender',
  components: {
    FormBuildItemWrapper
  },
  props: {
    formItemList: {
      required: true,
      type: Array
    },
    renderSence: {
      type: String,
      required: true
    },
    globalData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    moveFormItem: {
      type: Function,
      default: function() {
        return () => {}
      }
    },
    formData: {
      type: Object,
      default: () => {}
    },
    formRuleConfig: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data() {
    return {}
  },
  computed: {
    computedFormData: {
      get() {
        return this.formData
      },

      set(value) {
        this.$emit('update:formData', value)
        this.$emit('change', value)
      }
    }
  },
  methods: {
    draggableEvent($event, eventName) {
      this.$emit(eventName, $event)
    },
    itemOptionEvent($event, eventName) {
      this.$emit(eventName, $event)
    },
    updateFormItem(formItem, formIndex) {
      if (formItem) {
        this.formItemList[formIndex] = formItem
        this.$emit('update:formItemList', this.formItemList)
      }
    },
    handleComponentEvent(eventName, component) {
      this.$emit('handleComponentEvent', eventName, component)
    },
    handleConfigFormValidate(validateInfo) {
      const itemIndex = this.formItemList.findIndex((item) => item.componentConfig.uuid === validateInfo.uuid)
      if (itemIndex !== -1) {
        const selectedFormItem = this.formItemList[itemIndex]
        this.$set(selectedFormItem, 'validateInfo', validateInfo)
        this.$set(this.formItemList, itemIndex, selectedFormItem)
        this.$forceUpdate()
      }
    },
    validate(callback) {
      if (this.$refs.itemWrapper) {
        const itemWrappers = Array.isArray(this.$refs.itemWrapper) ? this.$refs.itemWrapper : [this.$refs.itemWrapper]
        itemWrappers.forEach((itemWrapper) => {
          if (!itemWrapper.widget.componentConfig.readOnly) { // 只读组件不校验
            itemWrapper.$refs.comp && itemWrapper.$refs.comp.validate && itemWrapper.$refs.comp.validate()
          }
        })
      }
      const unvalidateList = this.formItemList.filter((item) => item.validateInfo.validate === 'error')
      if (unvalidateList.length > 0) {
        callback(false, new Error(unvalidateList[0].validateInfo.msg))
      } else {
        callback(true)
      }
    },
    clearValidate() {
      this.formItemList.forEach((item) => {
        item.validateInfo = {
          validate: 'validate'
        }
      })
      this.$forceUpdate()
    },
    formEventEmit($event) {
      this.$emit('formEventEmit', $event)
    }
  }
}
</script>
<style lang="scss"></style>
